import { OnDestroy, OnInit, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DataService } from '../../_services';
import { DynamicDataTranslationService } from '../../_services/dynamicDataTranslationService';

@Pipe({
  name: 'translateWithDefault',
  pure: false
})
export class TranslateWithDefault implements PipeTransform, OnDestroy {
  subscriptions = [];
  onLangChange: Subscription;
  currentLabel = '';
  currentDefaultValue = '';
  constructor(
    private dynamicDataTranslationService: DynamicDataTranslationService,
    private translateService: TranslateService
  ) {
    this.onLangChange = this.translateService.onLangChange.subscribe(() => {
      this.transform(this.currentLabel, this.currentDefaultValue);
    });
  }

  ngOnDestroy(): void {
    this.onLangChange.unsubscribe();
  }

  transform(label: any, defaultVal: any = ''): any {
    this.currentLabel = label;
    this.currentDefaultValue = defaultVal;
    return this.dynamicDataTranslationService.getTranslatedTextForLabel(label, defaultVal);
  }

}
